import { Redirect } from 'react-router-dom'
import { PathRoutes } from 'enum/routes'

/**
 * Índice de Configuración (solo admin; ver RequireAccess en index.tsx).
 * Redirige al módulo de roles y permisos ABAC.
 */
const ConfigurationIndexRedirect = () => (
  <Redirect to={PathRoutes.ROLES_AND_PERMISSIONS} />
)

export default ConfigurationIndexRedirect
